<template>
  <div id="insure">
    <div class="text-center">
      <v-dialog
        v-model="dialog"
        activator="parent"
        width="auto"
      >
        <v-card class="insure-card">
          <v-card-text class="insure-txt">
            <h4 style="color: #FFCB05" :class="this.$lang === 'ar' ? 'bold-italic-ar' : 'bold-italic-en'">{{ active ? $t('deactivateType') : $t('activateType') }}</h4>
            <div class="px-4">
              {{ $t('insure')}} {{ active ? $t('deactivate') : $t('activate') }}
            </div>
            <div style="border-top: 2px solid rgba(0, 0, 0, 0.4);" :class="[this.$lang === 'ar' ? 'bold-ar' : 'bold-en', 'w-100 d-flex']">
              <button style="color: #FFCB05" :disabled="load" @click="handleActivation" class="insure-btn w-50">
                <div v-if="load" class="spinner-border text-dark" role="status">
                </div>
                <span v-if="!load">{{  $t('actions.ok') }}</span>
              </button>
              <div style="width: 1px; height: 100%; background: rgba(0, 0, 0, 0.4)"></div>
              <button @click="$emit('close')" class="insure-btn w-50">{{ $t('actions.cancel')}}</button>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>
<script>
import ChangeBundleStatusRepository from '../../repositories/ChangeBundleStatusRepository'
// import ChangeServiceStatusRepository from '../../repositories/ChangeServiceStatusRepository'
// import DeleteNumberRepository from '../../repositories/DeleteNumberRepository'
import ms from '../../utils/messeging.js'
import ChangeServiceStatusRepository from '../../repositories/ChangeServiceStatusRepository'
import ChangeOfferStatusRepository from '../../repositories/ChangeOfferStatusRepository'
export default {
  props: {
    active: Boolean,
    type: String,
    id: Number,
    method: String
  },
  data () {
    return {
      changeBundleRepo: new ChangeBundleStatusRepository(),
      changeServiceRepo: new ChangeServiceStatusRepository(),
      changeOfferRepo: new ChangeOfferStatusRepository(),
      // changeServiceRepo: new ChangeServiceStatusRepository(),
      // deleteRepo: new DeleteNumberRepository(),
      dialog: true,
      load: false
    }
  },
  created () {
  },
  methods: {
    async handleActivation () {
      if (this.type === 'bundles') {
        this.activateBundle()
      } else if (this.type === 'offers') {
        this.activateOffer()
      } else {
        this.activateService()
      }
    },
    async activateBundle () {
      const obj = this.changeBundleRepo
      const formData = new FormData()
      // this.$store.state.passedNum
      formData.append('gsm', this.$store.state.selectedNumber)
      formData.append('bundleId', this.id)
      formData.append('state', this.active ? 0 : 1)
      formData.append('bundleType', 0)
      const params = formData
      this.load = true
      try {
        const response = await obj[this.method](params)
        if (response.data.status === 200) {
          ms.successMessage(response.data.message)
          this.$emit('refresh')
          this.$emit('close')
        } else {
          ms.errorMessage(response.data.message)
        }
      } catch (e) {
        console.log(e)
        ms.errorMessage('Some thing went wrong')
      }
      this.load = false
    },
    async activateService () {
      const obj = this.changeServiceRepo
      const formData = new FormData()
      // this.$store.state.passedNum
      formData.append('gsm', this.$store.state.selectedNumber)
      formData.append('serviceId', this.id)
      formData.append('state', this.active ? 0 : 1)
      // formData.append('bundleType', 0)
      const params = formData
      this.load = true
      try {
        const response = await obj[this.method](params)
        if (response.data.status === 200) {
          ms.successMessage(response.data.message)
          this.$emit('refresh')
          this.$emit('close')
        } else {
          ms.errorMessage(response.data.message)
        }
      } catch (e) {
        ms.errorMessage('Some thing went wrong')
      }
      this.load = false
    },
    async activateOffer () {
      const obj = this.changeOfferRepo
      const formData = new FormData()
      // this.$store.state.passedNum
      formData.append('gsm', this.$store.state.selectedNumber)
      formData.append('offerId', this.id)
      formData.append('state', this.active ? 0 : 1)
      // formData.append('serviceType', 0)
      const params = formData
      this.load = true
      try {
        const response = await obj[this.method](params)
        if (response.data.status === 200) {
          ms.successMessage(response.data.message)
          this.$emit('refresh')
          this.$emit('close')
        } else {
          ms.errorMessage(response.data.message)
        }
      } catch (e) {
        console.log(e)
        ms.errorMessage('Some thing went wrong')
      }
      this.load = false
    }
  }
}
</script>
<style>
.insure-btn {
  height: 45px;
}
</style>
<style lang="scss">
@import "src/assets/sass/main";
  button {
    height: 45px;
  }
  .v-dialog__content.v-dialog__content--active {
    backdrop-filter: blur(20px) !important;
  }
  .v-card__text.insure-txt {
    height: 200px !important;
    width: 300px !important;
    padding: 1rem 0 0 0  !important;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
  }
.insure-card.v-card.v-sheet.theme--light {
  box-shadow: none;
  border-radius: 25px;
}
</style>
